<template>
  <div v-if="!isLoading" class="class-drag">
    <!-- arrastrar fichero -->
    <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
      <h3 class="text-center">{{ $t("soltar-archivo") }}</h3>
    </div>
    <div class="row">
      <div class="col-md-12">
        <span
          class="badge badge-primary mr-1 pb-0"
          v-for="titulo in titulos"
          :key="titulo.id"
        >
          {{ titulo.dog_titles.titulo }}
          <a
            class="btn btn-sm p-0 mx-0 ml-1"
            style="min-width:0px"
            v-tooltip="{ content: $t('eliminar') }"
            @click="eliminarTitulo({ id: titulo.id, dogId: titulo.dog_id })"
          >
            <i class="fa fa-times ml-1"></i>
          </a>
        </span>

        <button
          v-if="!showAddNewTitle"
          class="btn btn-sm btn-outline-primary p-1 m-0"
          @click.prevent="showAddNewTitle = true"
        >
          {{ $t("nuevo titulo") }}
          <i class="fa fa-plus ml-1"></i>
        </button>
        <button
          v-if="showAddNewTitle"
          class="btn btn-sm btn-outline-danger p-1 m-0"
          @click.prevent="showAddNewTitle = false"
        >
          {{ $t("cancelar") }}
          <i class="fa fa-minus ml-1"></i>
        </button>
      </div>
    </div>

    <div class="row mt-2" v-if="showAddNewTitle">
      <div class="col-12">
        <div class="card border">
          <div class="card-header py-1">
            {{ $t("nuevo titulo") }}
          </div>
          <div class="card-body px-1 px-md-3">
            <div class="row">
              <div class="col-12">
                <label>{{ $t("nuevo titulo") }}</label>
                <select class="my-2 form-control" v-model="tituloSelected">
                  <option value="0"
                    >{{ $t("seleccionar una opcion") }}...</option
                  >
                  <option
                    v-for="tit in compListaTitulosFiltered"
                    :key="tit.id"
                    :value="tit.id"
                    >{{ tit.titulo }}</option
                  >
                </select>
              </div>
            </div>
            <!-- componente upload files -->
            <div class="row">
              <!-- lista de ficheros seleccionados -->
              <div class="col-12" v-if="files.length">
                <ul class="list-group">
                  <li
                    class="list-group-item"
                    v-for="(file, index) in files"
                    :key="file.id"
                  >
                    <span>{{ file.name }}</span> -
                    <span>{{ file.size | formatSize }}</span> -
                    <span v-if="file.error">{{ file.error }}</span>
                    <span v-else-if="file.success">success</span>
                    <span v-else-if="file.active">active</span>
                    <span v-else></span>
                  </li>
                </ul>
              </div>
              <!-- o si no tenemos ninguno mostramos la caja -->
              <div class="col-12" v-else>
                <div class="text-center p-3  rounded border">
                  <h5>{{ $t("arrastrar-fichero") }}</h5>
                </div>
              </div>
            </div>
            <!-- los botones -->
            <div class="row mt-1">
              <div class="col-12">
                <div class="example-btn">
                  <file-upload
                    class="btn btn-sm btn-primary btn-xs-block"
                    :headers="compHeaders"
                    :post-action="rutaPost"                   
                    :data='{nombre: "pepe", apellidos: "apellidos"}'
                    :extensions="['jpg', 'png', 'pdf']"
                    :multiple="false"
                    :drop="true"
                    :drop-directory="false"
                    v-model="files"
                    ref="upload"
                    input-id="file"
                  >
                    <i class="fa fa-plus"></i>
                    {{ $t("seleccionar archivo") }}
                  </file-upload>
                  <button
                    type="button"
                    v-if="files.length === 1"
                    class="btn btn-sm btn-secondary btn-xs-block"
                    @click.prevent="$refs.upload.clear()"
                  >
                    <i class="fa fa-stop" aria-hidden="true"></i>
                    Limpiar
                  </button>

                  <button
                    v-show="files.length > 0 && tituloSelected > 0"
                    type="button"
                    class="btn btn-sm btn-success float-right btn-xs-block"
                    v-if="!$refs.upload || !$refs.upload.active"
                    @click.prevent="$refs.upload.active = true"
                  >
                    <i class="fa fa-arrow-up" aria-hidden="true"></i>
                    {{ $t("guardar") }}
                  </button>
                </div>
              </div>
            </div>
            <!-- componente upload files -->
          </div>
        </div>
      </div>
    </div>

    <button
      class="btn btn-sm btn-success p-1 m-0 mr-1 mt-1"
      @click.prevent="guardarTitulo"
    >
      {{ $t("guardar") }}
    </button>
  </div>
</template>

<script>
import VueUploadComponent from "vue-upload-component";
import { mapActions } from "vuex";
import { authHeader } from "@/_helpers/auth-header";
import { config } from '@/_config';


export default {
  name: "dog-title-badge-comp",
  components: {
    FileUpload: VueUploadComponent,
  },
  props: ["titulos", "dogId"],
  data: () => ({
    showAddNewTitle: false,
    listaTitulos: null,
    isLoading: true,
    tituloSelected: 0,
    files: [],
    rutaPost: `${config.apiUrl}/uploadtitleDogDoc`
  }),
  methods: {
    ...mapActions("dog", ["callGetAllDogTitles"]),
    async customUpload(file, component) {
        console.log(component)
    // return await component.uploadHtml4(file);
    },
    guardarTitulo() {
      this.$refs.upload.active = true;
     // return;
      if (this.tituloSelected > 0 && this.tituloSelected !== null) {
        const misDatos = { title_id: this.tituloSelected };
        this.$emit("emitCreateDogTitleBadge", misDatos);
        this.tituloSelected = 0;
      }
    },
    eliminarTitulo(objData) {
      this.$emit("emitDeleteDogTitleBadge", objData);
      this.tituloSelected = 0;
    },
  },
  mounted() {
    this.callGetAllDogTitles().then((res) => {
      this.listaTitulos = res.data;
      this.isLoading = false;
    });
  },
  computed: {     
    /* comp Header bearer */
    compHeaders() {
      return {
        ...authHeader(),
      };
    },
    compListaTitulosFiltered: function() {
      if (this.listaTitulos === null) return;
      let tmp = [];
      this.listaTitulos.forEach((x) => {
        const existe = this.titulos
          .map((d) => {
            return d.title_id;
          })
          .includes(x.id);
        if (!existe) {
          tmp.push({ id: x.id, titulo: x.titulo });
        }
      });

      return tmp;
    },
  },
  filters: {
    formatSize: function(value) {
      const salida = value < 1024000 ? value / 1024 : value / 1024000;
      const tipo = value < 1024000 ? "Kb" : "Mb";
      return `${salida.toFixed(2)} ${tipo}`;
    },
  },
};
</script>

<style scoped>
/* media mobile < 500 */
@media all and (max-width: 480px) {
  .btn-xs-block {
    width: 100%;
    display: block;
    margin-top: 1px !important;
  }
}
span {
  font-size: 0.6em;
}
button {
  min-width: 0px !important;
}
select {
  background-color: white;
  border: 1px solid #ccc;
  padding: 0px 20px 0px 0px !important;
  min-height: 0px !important;
  height: 24px !important;
}

.class-drag label.btn {
  margin-bottom: 0;
  margin-right: 1rem;
}
.class-drag .drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: 0.6;
  text-align: center;
  background: #000;
}
.class-drag .drop-active h3 {
  margin: -0.5em 0 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 40px;
  color: #fff;
  padding: 0;
}
</style>
